import React from 'react';
import { Typography, Link, Card, CardContent, Box, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '90vh',  // To center the card vertically
        padding: 2, // Add padding around the edges
      }}
    >
      <Card
        sx={{
          maxWidth: 500,
          width: '100%',
          boxShadow: 3, // Adding a subtle shadow for better depth
          borderRadius: 2, // Rounded corners for a softer appearance
        }}
      >
        <CardContent>
          <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2, textAlign: 'center' }}>
            {t("Contact.title")}
          </Typography>
          <Divider sx={{ marginBottom: 2 }} /> {/* Add a divider for better separation */}

          <Typography variant="body1" sx={{ marginBottom: 2 }}>
            {t("Contact.description")}
          </Typography>

          <Box sx={{ listStyleType: 'none', paddingLeft: 0 }}>
            <Box sx={{ marginBottom: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {t("Contact.line")}
              </Typography>
              <Link
                href="https://line.me/ti/p/9KctLVGWWt"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'primary.main',
                  '&:hover': { textDecoration: 'underline' }, // Add hover effect for links
                }}
              >
                {t("Contact.line_link")}
              </Link>
            </Box>
            <Box sx={{ marginBottom: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {t("Contact.facebook")}
              </Typography>
              <Link
                href="https://www.facebook.com/profile.php?id=100090315915109"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'primary.main',
                  '&:hover': { textDecoration: 'underline' }, // Add hover effect for links
                }}
              >
                {t("Contact.facebook_link")}
              </Link>
            </Box>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {t("Contact.email")}
              </Typography>
              <Link
                href="mailto:max@tothemax.info"
                sx={{
                  color: 'primary.main',
                  '&:hover': { textDecoration: 'underline' }, // Add hover effect for links
                }}
              >
                {t("Contact.email_link")}
              </Link>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Contact;
